import { SpawnerBuilding } from "./SpawnerBuilding";

export class House extends SpawnerBuilding {
    readonly id = "house";
    readonly displayName = "House";
    readonly spawns = "peasant";
    readonly maxSpawns = 4;
    description() { return "Spawns Peasasnts."; }
    maxCooldown() { return 5000; }
}
